import { Lang } from 'cat-shared/utils'

export default {
  [Lang.EN]: {
    intro: {
      header: 'Can Answer That ?',
      subheader1: 'Quiz web application',
      subheader2: 'for testing your knowledge and learning',
    },
    stats: {
      user_zero: 'users',
      user_one: 'user',
      user: 'users',
      question_zero: 'questions',
      question_one: 'question',
      question: 'questions',
      answer_zero: 'answers',
      answer_one: 'answer',
      answer: 'answers',
    },
    latestQuestions: {
      button: 'See the latest questions',
    },
    about: {
      button: 'About the app',
    },
    startAnswering: {
      button: "Let's start !",
    },
    topUsers: {
      header: 'Users with most correct answers',
    },
    topQuestions: {
      header: 'Most popular questions',
    },
  },
}
